// SEO por ruta. La fuente es seoRutas.json, que también lee server.js para el HTML inicial
// (lo que ven Google, Facebook y WhatsApp) y para generar /sitemap.xml.
import React from 'react';
import { Helmet } from 'react-helmet';
import SEO from './seoRutas.json';

const normalizarRuta = (pathname) => {
    let ruta = pathname;
    try { ruta = decodeURIComponent(pathname); } catch (e) { /* ruta mal codificada: se usa tal cual */ }
    return ruta.length > 1 ? ruta.replace(/\/+$/, '') : ruta;
};

export const buscarSeo = (pathname) => {
    const ruta = normalizarRuta(pathname);
    if (SEO.rutas[ruta]) return { ...SEO.rutas[ruta], ruta };
    const patron = SEO.patrones.find(p => new RegExp(p.regex).test(ruta));
    if (patron) return { ...patron, ruta };
    return { ...SEO.noEncontrada, ruta };
};

export const SeoRuta = ({ pathname }) => {
    const seo = buscarSeo(pathname);
    const url = SEO.sitio + (seo.ruta === '/' ? '/' : seo.ruta);
    const indexar = seo.indexar !== false;
    return (
        <Helmet>
            <title>{seo.titulo}</title>
            <meta name="description" content={seo.descripcion} />
            <meta name="robots" content={indexar ? 'index, follow' : 'noindex, follow'} />
            {indexar && <link rel="canonical" href={url} />}
            <meta property="og:url" content={url} />
            <meta property="og:title" content={seo.titulo} />
            <meta property="og:description" content={seo.descripcion} />
        </Helmet>
    );
};
